import type { UnitPreference } from '../types';
import { kgToLb, lbToKg } from '../units';
import { Field } from './Field';

type WeightInputProps = {
  label: string;
  /** Always in kg — the canonical unit. Caller stores kg in the DB. */
  value_kg: number | null;
  onChange: (next_kg: number | null) => void;
  unit: UnitPreference;
  hint?: string | undefined;
  placeholder?: string | undefined;
};

// Single source of truth: kg. The displayed/typed value flips based on `unit`,
// converted on the way in/out so the parent never has to think about lb.
export function WeightInput({ label, value_kg, onChange, unit, hint, placeholder }: WeightInputProps) {
  const displayValue =
    value_kg === null ? '' : unit === 'imperial' ? String(kgToLb(value_kg)) : String(value_kg);

  return (
    <Field label={label} hint={hint}>
      <div className="unit-row">
        <input
          className="input"
          type="number"
          inputMode="decimal"
          step="0.1"
          min="0"
          placeholder={placeholder ?? (unit === 'imperial' ? 'e.g. 180' : 'e.g. 82')}
          value={displayValue}
          onChange={(e) => {
            const raw = e.target.value;
            if (raw === '') {
              onChange(null);
              return;
            }
            const n = Number(raw);
            if (!Number.isFinite(n)) return;
            onChange(unit === 'imperial' ? lbToKg(n) : +n.toFixed(2));
          }}
        />
        <div className="input input--small" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'default' }}>
          {unit === 'imperial' ? 'lb' : 'kg'}
        </div>
      </div>
    </Field>
  );
}
